module.exports = __webpack_public_path__ + "img/logo.7a56f108.png";